import(/* webpackMode: "eager" */ "/usr/src/app/src/app/(auth)/auth/login/page.tsx");
